import React from "react";
import { Route, Routes } from "react-router-dom";
import GeneralLedgerDetailScreen from "screens/App/CRM/GeneralLedger/GeneralLedgerDetailScreen";
import GeneralLedgerListscreen from "screens/App/CRM/GeneralLedger/GeneralLedgerListscreen";

const GeneralLedgerRouter = () => {
  return (
    <Routes>
      <Route path="list" element={<GeneralLedgerListscreen />} />
      <Route path=":id/detail" element={<GeneralLedgerDetailScreen />} />
    </Routes>
  );
};

export default GeneralLedgerRouter;
